import { render, staticRenderFns } from "./our-team-page.html?vue&type=template&id=7179c924&scoped=true&external"
import script from "./our-team-page.js?vue&type=script&lang=js&external"
export * from "./our-team-page.js?vue&type=script&lang=js&external"
import style0 from "./our-team-page.scss?vue&type=style&index=0&id=7179c924&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179c924",
  null
  
)

export default component.exports